import React, { useState, useEffect } from 'react';
import CampoLimiteMonto, { limiteDe } from './CampoLimiteMonto';
import './OperatorModalStyles.css';

// Rol y monto máximo de transferencias de un colaborador. Los administradores ven
// todo, así que al pasar a administrador el límite se borra.
function EditOperatorModal({ operator, onClose, onSave, limiteCuenta }) {
    const [rol, setRol] = useState('operador');
    const [limite, setLimite] = useState('');
    const [error, setError] = useState(null);
    const [guardando, setGuardando] = useState(false);

    useEffect(() => {
        if (!operator) return;
        setRol(operator.admin ? 'administrador' : 'operador');
        setLimite(operator.limite_monto ? String(operator.limite_monto) : '');
        setError(null);
    }, [operator]);

    if (!operator) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setGuardando(true);
        setError(null);
        try {
            const admin = rol === 'administrador';
            await onSave(operator, { admin, limite_monto: admin ? null : limiteDe(limite) });
            onClose();
        } catch (err) {
            console.error('Error al editar operador:', err);
            setError('No se pudieron guardar los cambios. Intentá de nuevo.');
        } finally {
            setGuardando(false);
        }
    };

    return (
        <div className="modal-overlay" onClick={(e) => {
            if (e.target === e.currentTarget) onClose();
        }}>
            <div className="modal-content add-operator-modal">
                <div className="modal-header">
                    <h2>Editar colaborador</h2>
                    <button className="close-button" onClick={onClose}>×</button>
                </div>

                <div className="editar-operador__quien">
                    <strong>{operator.nombre || operator.fullName}</strong>
                    <span>{operator.email}</span>
                </div>

                <form onSubmit={handleSubmit} className="add-operator-form">
                    <div className="operator-form-group">
                        <label className="operator-form-label" htmlFor="editar-rol">
                            Rol
                        </label>
                        <select
                            id="editar-rol"
                            value={rol}
                            onChange={(e) => setRol(e.target.value)}
                            className="operator-form-input"
                            disabled={guardando}
                        >
                            <option value="operador">Operador</option>
                            <option value="administrador">Administrador</option>
                        </select>
                    </div>

                    {rol === 'operador' ? (
                        <CampoLimiteMonto
                            id="editar-limite"
                            valor={limite}
                            onChange={setLimite}
                            disabled={guardando}
                            limiteCuenta={limiteCuenta}
                        />
                    ) : (
                        <p className="role-description">
                            Los administradores ven todas las transferencias.
                        </p>
                    )}

                    {error && <div className="error-message">{error}</div>}

                    <div className="form-actions">
                        <button type="button" onClick={onClose} className="cancel-button" disabled={guardando}>
                            Cancelar
                        </button>
                        <button type="submit" className="submit-button" disabled={guardando}>
                            {guardando ? 'Guardando...' : 'Guardar'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default EditOperatorModal;
